import React from 'react'

const Company = () => {
  return (
    <div className='block'>
      <div className="bottomWhy d-flex">
        <div className="d-flex whydetails">
        <div className="">
          <div className="heading">
            <h2 style={{fontSize: "4rem"}}>You have a job. We have 8m+ job seekers.</h2>
            <p style={{fontSize:"1.5rem", lineHeight:"150%"}}>8 million startup-ready candidates from around the world, unique details you can't find anywhere else, and all the tools you need to hire - get everything set up in 10 minutes, for free.</p>
          </div>
        <button type="button" className="btn btn-outline-dark login mx-1 my-2">Sign Up Now</button>
        </div>
        </div>
        <div className="whypic">
        <img width={"100%"} style={{aspectRatio:"1/1"}} src="https://img.freepik.com/free-vector/setup-concept-illustration_114360-242.jpg?w=740&t=st=1690910674~exp=1690911274~hmac=ffb63d0cfbb1e51ca39f84e0cdfe8210ff1f4d54b222d0b3d6e2b8fef565dd1f" alt="" />
        </div>
      </div>

      <div className="topWhy d-flex">
        <div className="whypic">
        <video loop="" autoPlay="" className="video-embed" style={{width:"100%"}} >
          <source src="https://angel.co/images/gtm/GIF-RecruiterCuratedAndCuratedGlobal.mp4" type="video/mp4"/>
        </video>
        </div>
        <div className="d-flex whydetails">
        <div className="">
          <div className="heading"><h2>8 million startup-ready candidates</h2></div>

          <div className="icon-list mb-40-lg"><div className="icon-list_item d-flex"><img src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d7128760027e63b4_Unique%20Candidate.svg" loading="lazy" alt="" className="icon-list_icon mx-2"/><div className="icon-list-content"><h4 className="mb-8">Top tech talent</h4><div>Engineers, PMs, designers, sales, &amp; marketing</div></div></div><div className="icon-list_item d-flex"><img src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d71287650b7e63bc_Global.svg" loading="lazy" alt="" className="icon-list_icon mx-2"/><div className="icon-list-content"><h4 className="mb-8">Worldwide focus</h4><div>Local &amp; remote candidates in the US and abroad</div></div></div><div className="icon-list_item d-flex"><img src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d7128716b37e63bb_Team.svg" loading="lazy" alt="" className="icon-list_icon mx-2"/><div className="icon-list-content"><h4 className="mb-8">Startup-ready</h4><div>Candidates on our platform are specifically interested in startups</div></div></div></div>
        </div>
        </div>
      </div>

      <div className="bottomWhy d-flex">
        <div className="d-flex whydetails">
        <div className="">
          <div className="heading">
            <h2>Unique candidate details you can't find anywhere else</h2>

            <div className="icon-list mb-40-lg">
              <div className="icon-list_item d-flex"><img src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d7128747b87e63bf_Toggle.svg" loading="lazy" alt="" className="icon-list_icon mx-2"/><div className="icon-list_text"><b>Job search status</b> - we'll tell you if a candidate is ready to interview or open to offers</div></div>
              <div className="icon-list_item d-flex"><img src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d7128717f77e63b9_List.svg" loading="lazy" alt="" className="icon-list_icon mx-2"/><div className="icon-list_text "> <strong>Skills &amp; experience</strong> - we give candidates the ability to showcase this in unique ways, like detailing their biggest accomplishment</div></div>
              <div className="icon-list_item d-flex"><img src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d7128781547e63bd_Time.svg" loading="lazy" alt="" className="icon-list_icon mx-2"/><div className="icon-list_text"><strong>Timezones </strong>- you can filter by timezones and see exactly how many hours ahead or behind a candidate is</div></div>
              <div className="icon-list_item d-flex"><img src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d7128781547e63bd_Time.svg" loading="lazy" alt="" className="icon-list_icon mx-2"/><div className="icon-list_text"><strong>Remote preferences</strong> - search by candidates who are open to remote work and see what kind of remote culture they're looking for</div></div>
              <div className="icon-list_item d-flex"><img src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d712876c2d7e63b5_Vetting.svg" loading="lazy" alt="" className="icon-list_icon mx-2"/><div className="icon-list_text"><strong>Assessments</strong> - see video and engineering assessments to help you evaluate skills further</div></div>
            </div>

          </div>
        <button type="button" className="btn btn-outline-dark login mx-1 my-2">Find Talents</button>
        </div>
        </div>
        <div className="whypic">
        <img width={"100%"} src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d7128729267e63ef_AssessmentsProfile.png" loading="lazy" sizes="(max-width: 479px) 90vw, (max-width: 767px) 83vw, (max-width: 991px) 487px, 39vw" alt="Unique candidate details displayed on profile" srcset="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d7128729267e63ef_AssessmentsProfile-p-500.png 500w, https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d7128729267e63ef_AssessmentsProfile.png 712w"/>
        </div>
      </div>

      <div className='block d-flex companyfoot' style={{width: "100%"}}>
        
        <h3>All the tools you need to hire, all in one place.</h3>
        <p>Get everything set up within <span style={{fontWeight:"bold"}}>10 minutes or less</span></p>
        
      </div>

      <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner carouselContainer">
          <div className="carousel-item  ">
            <div className='d-flex caroselCont'>
              <div className="carouselLeft">
              <img src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d71287e8d07e63f1_Message.png" className='caroselImg' style={{width:"80%"}} loading="lazy"/>
              </div>
              <div className="carouselRight icon-list_text">
              <div className="">
                <div className="heading">
                  <h3>Source from 8M startup-ready candidates</h3>
                  <div className="icon-list mb-40-lg">
                    <div className="icon-list_item d-flex"><div className="icon-list_text">Filter down our 8M candidates to find the most relevant match for your role. Use basic search filters, or upgrade to Recruit Pro for unlimited access to advanced candidate filters.</div></div>
                  </div>
                </div>
                <button type="button" className="btn btn-outline-dark login mx-1 my-2">Sign Up</button>
              </div>
              </div>
            </div>
          </div>
          <div className="carousel-item active ">
            <div className='d-flex caroselCont'>
              <div className="carouselLeft">
              <img src="https://assets-global.website-files.com/636dd759d71287e8ac7e6280/636dd759d71287e8d07e63f1_Message.png" className='caroselImg' style={{width:"80%"}} loading="lazy"/>
              </div>
              <div className="carouselRight icon-list_text">
              <div className="">
                <div className="heading">
                  <h3>Source from 8M startup-ready candidates</h3>
                  <div className="icon-list mb-40-lg">
                    <div className="icon-list_item d-flex"><div className="icon-list_text">Filter down our 8M candidates to find the most relevant match for your role. Use basic search filters, or upgrade to Recruit Pro for unlimited access to advanced candidate filters.</div></div>
                  </div>
                </div>
                <button type="button" className="btn btn-outline-dark login mx-1 my-2">Sign Up</button>
              </div>
              </div>
            </div>
          </div>
          
        </div>
        <button className="carousel-control-prev"  type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
          <span className="carousel-control-prev-icon"  aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      <div className='block d-flex companyfoot2' style={{width: "100%"}}>
        
        <h1>Join the 100K+ startups building their teams with us.</h1>
        
      </div>
    </div>
  )
}

export default Company